import { ID, IntlMessage } from "../Intl";

export function email(value: string | null): IntlMessage | undefined {
  //eslint-disable-next-line
  const regexp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
  return value && !regexp.test(value) ? ID("valid.email") : undefined;
}
